import { useContext } from "react";
import { Grid, Card, CardContent, Typography } from '@material-ui/core';
import { Formik, Form } from 'formik';
import { Spinner } from "components";
import { ticketContext } from "../../TicketContext";
import { messageContext, messageSchema } from './MessagesContext';
import Message from './Message';
import MessageEditor from './MessageEditor';
import { appUserContext } from "helpers/services";
import { UserType } from "helpers/enums";


let Messages = () => {
    let { currentUser } = useContext(appUserContext);
    let { ticket } = useContext(ticketContext);
    let { isLoading, messages, isValidMessage, saveMessage } = useContext(messageContext);

    
    return (
        <Grid container>
            {isLoading && <Spinner />}
            {isLoading === false &&
                <>
                    {currentUser?.typology === UserType.VitecUser && ticket.hasCustomerServiceAssignee === false &&
                        <Grid item xs={12}>
                            <Typography>Please choose a Customer Service Assignee to send messages</Typography>
                        </Grid>
                    }
                    
                    {(currentUser?.typology === UserType.Customer
                        || (currentUser?.typology === UserType.VitecUser && ticket.hasCustomerServiceAssignee === true)) &&

                        <Grid item xs={12}>
                            <Formik
                                enableReinitialize={true}
                                validationSchema={messageSchema}
                                initialValues={messageSchema.getDefault()}
                                onSubmit={async (values, actions) => {
                                    if (isValidMessage(values.text) === false)
                                        actions.setFieldError("text", 'You must provide valid message');
                                    else {
                                        await saveMessage(values);
                                        actions.setSubmitting(false);
                                        actions.resetForm();
                                    }
                                }}
                            >
                                <Form>
                                    <Card>
                                        <CardContent>
                                            {currentUser?.typology === UserType.VitecUser &&
                                                <Typography>Write an internal note
                                                    {currentUser?.canReplyToCustomer === true && <> or a message to '{ticket.reporterName}&nbsp;&middot;&nbsp;{ticket.reporterCompany}'</>}
                                                </Typography>
                                            }
                                            <MessageEditor ticketId={ticket.id} />
                                        </CardContent>
                                    </Card>
                                </Form>
                            </Formik>
                        </Grid>
                    }
                    {messages.length === 0 &&
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">There are no messages</Typography>
                        </Grid>
                    }
                    {messages.map((message) =>
                        <Grid item xs={12} key={message.messageId}>
                            <Message message={message} />
                        </Grid>
                    )}
                </>
            }
        </Grid>
    )
}

export default Messages;